var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.newMessages > 0 && _vm.showBadgeAtNavigationItem)?_c('div',{staticClass:"newMessageAlert",class:_vm.displayStyle},[_vm._v(" "+_vm._s(_vm.newMessages)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }